// 引入axios
import axios from 'axios'

const request = axios.create({
    // baseURL: '/api',
    // baseURL: 'http://dzxy.sdyunyou.cn/api',
    baseURL: 'https://request.sdklab-biophysics-dzu.net/api',
    timeout: 10000000
})

// 请求拦截
request.interceptors.request.use((config) => {

    return config

}, err => {
    return Promise.reject(err)
})

// 响应拦截
request.interceptors.response.use((res) => {

    return res.data
    
}, err => {
    return Promise.reject(err)
})

export default request